export default __webpack_public_path__ + "static/media/icon__1.f27c9762.svg";